module.exports = __webpack_public_path__ + "static/media/Instagram.4a8c2347.png";